function initializeCarousel(carouselClass) {
  const dots = document.querySelectorAll(`.${carouselClass} .dot--landing`);
  const slidesText = document.querySelectorAll(`.${carouselClass} .carousel-text`);
  const slides = document.querySelectorAll(`.${carouselClass} .realisations-container-slide`);
  let slideIndex = 0;
  let timer = null;
  const timerDurationMilliseconds= 3000

  function currentSlide(index) {
    slides.forEach((slide) => {
      slide.style.display = "none";
      slide.classList.remove("active");
    });
    slidesText.forEach((slideText) => {
      slideText.classList.remove("active");
    });
    dots.forEach((dot) => {
      dot.classList.remove("active");
    });
    slides[index].style.display = "grid";
    dots[index].classList.add("active");
    slides[index].classList.add("active");
    slidesText[index].classList.add("active");
    timer = setTimeout(nextSlide, timerDurationMilliseconds)
  }

  function nextSlide() {
    slideIndex++;
    if (slideIndex >= slides.length) {
      slideIndex = 0;
    }
    currentSlide(slideIndex);
  }

  currentSlide(0);

  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      slideIndex = index;
      if (timer) {
        clearTimeout(timer)
      }
      currentSlide(index);
    });
  });
}

initializeCarousel("carousel-desktop");
initializeCarousel("carousel-mobile");